import { HStack } from "@chakra-ui/react";
import { Text12 } from "components/Text";
import CDS, { Icon } from "design-system";

interface TriggerTimingProps {
  descriptor?: string;
}

export default function TriggerTiming({ descriptor }: TriggerTimingProps) {
  if (!descriptor) return null;

  return (
    <HStack spacing="1" align="center">
      <Icon type="clock" size="sm" color={CDS.Color.text.secondary} />
      <Text12 color="fg.muted">{descriptor}</Text12>
    </HStack>
  );
}
